import React from "react";
import Logo from "../../../images/logo.svg";
import loginImage from "images/login-image.png";
import { Typography, Flex } from "antd";

function SignupPagePreview({ type, gym, headerText = "", subText = "", image }) {
	const ref = React.useRef();
	const getImageUrl = (image) => {
		if (!image) return loginImage;
		if (typeof image === "string") {
			return image;
		}
		return URL.createObjectURL(image);
	};

	const imageUrl = getImageUrl(image);

	return (
		<div style={{ display: "flex", width: "100%", height: "100%", flexDirection: "column", borderRadius: "5px" }}>
			<div
				style={{
					display: "flex",
					height: "100%",
					width: "100%",
					justifyContent: "space-between",
				}}
			>
				<div
					style={{
						display: "flex",
						height: "100%",
						flexDirection: "column",
						flex: 1,
						backgroundColor: "#f4f6f7",
						padding: "8px",
					}}
				>
					<div>
						<img
							className="sb-login__container__form-container__header__image"
							src={Logo}
							alt="logo"
							height={8}
							style={{ marginBottom: 8, padding: 0, height: 8 }}
						/>
					</div>

					<Flex vertical style={{ margin: "8px 0" }}>
						<div
							style={{
								fontWeight: 700,
								fontSize: "12px",
								lineHeight: "12px",
								textTransform: "uppercase",
								lineClamp: 2,
							}}
						>
							{headerText.substring(0, 47)}
							{headerText.length > 47 ? "..." : ""}
						</div>
						<div style={{ fontWeight: 500, fontSize: "8px", color: "#4f5661", textTransform: "uppercase" }}>
							{subText.substring(0, 47)}
							{subText.length > 47 ? "..." : ""}
						</div>
					</Flex>
					<div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
						<span style={{ fontSize: "8px", fontWeight: 700, color: "#4f5661" }}>PHONE NUMBER OR EMAIL ADDRESS</span>
						<div
							style={{
								border: ".5px solid #e3e5e7",
								borderRadius: "100px",
								height: "16px",
								boxSizing: "border-box",
							}}
						></div>
						<span style={{ fontSize: "8px", fontWeight: 700, color: "#4f5661" }}>PASSWORD</span>
						<div
							style={{
								border: ".5px solid #e3e5e7",
								borderRadius: "100px",
								height: "16px",
								boxSizing: "border-box",
							}}
						></div>{" "}
					</div>
					<Flex justify="flex-end" align="center">
						<Typography.Text style={{ fontSize: "8px", margin: "8px 0" }} strong>
							Forgot Password?
						</Typography.Text>
					</Flex>
					<div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
						<div
							style={{
								backgroundColor: "black",
								borderRadius: "100px",
								height: "20px",
								boxSizing: "border-box",
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
								color: "white",
								fontSize: "8px",
								fotWeight: 700,
							}}
						>
							<span>LOGIN</span>
						</div>
						<div
							style={{
								backgroundColor: gym?.brand_color1 ? gym?.brand_color1 : "black",
								borderRadius: "100px",
								height: "20px",
								boxSizing: "border-box",
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
								color: "white",
								fontSize: "8px",
								fotWeight: 700,
							}}
						>
							<span>SIGN UP</span>
						</div>
					</div>
				</div>
				<div
					ref={ref}
					style={{
						display: "flex",
						backgroundColor: "black",
						minWidth: "45%",
						height: (ref?.current?.offsetWidth * 16) / 9,
						backgroundImage: `url(${imageUrl})`,
						backgroundSize: "cover",

						backgroundPosition: "center",
					}}
				></div>
			</div>
		</div>
	);
}

export default SignupPagePreview;

